import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
    Button,
    CircularProgress,
    Grid,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Paper,
    PaperProps
} from "@mui/material";
import { useState } from "react";
import { useDataProvider, useRefresh } from "react-admin";
import ApiResources from "src/providers/ApiResources";
import { OrderItemProps } from "src/resources/sales/interface";
import { useForm } from "react-hook-form";
import Draggable from 'react-draggable';

interface RemoveItemModalProps {
    orderItem: OrderItemProps;
    open: boolean;
    setOpen: any;
}

const PaperComponent = (props: PaperProps) => {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

export const RemoveItemModal = (props: RemoveItemModalProps) => {
    const { orderItem, open, setOpen } = props;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { register, control, handleSubmit, getValues, setValue, formState: { errors }} = useForm();
    const dataProvider = useDataProvider();
    const refresh = useRefresh();
    
    const remove = async (data) => {
        try {
            let formData = {...data};

            setLoading(true);
            setError(null);
            dataProvider
            .delete(ApiResources.deleteOrderItem(false), {
                id: orderItem.id,
            })
            .then((res) => {
                setLoading(false);
                refresh();
                setOpen(false);
            })
            .catch((error) => {
                setError(error.message);
                setLoading(false);
            });
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <Dialog
            onClose={() => setOpen(false)}
            open={open}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            fullWidth={true}
            maxWidth="sm"
        >
            <form onSubmit={handleSubmit(remove)}>
            <DialogTitle sx={{padding: "18px"}}>
                <Typography variant="body1" sx={{fontSize: "20px", fontWeight: "500"}}>{`Remove Item ${orderItem.product?.name} ${orderItem.product?.sku}`}</Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{padding: "18px !important"}}>
                <Grid container item sm={12} rowSpacing={1} columnSpacing={2}>
                    <Grid item sm={12} md={12}>
                        <Typography variant="subtitle1">Are you sure you want to remove this item?</Typography>
                    </Grid>

                    { error &&
                    <Grid item sm={12} md={12} sx={{display: "flex"}}>
                        <Typography variant="subtitle2" color="error">{error}</Typography>
                    </Grid>                     
                    } 
                </Grid>
            </DialogContent>
            <DialogActions sx={{padding: "18px"}}>
                <Button
                    variant="outlined"
                    onClick={() => {
                    setOpen(false);
                    }}
                >
                    Cancel
                </Button>
                <Button variant="contained" type="submit" disabled={loading}>
                    {loading && <CircularProgress size={18} thickness={2} sx={{ fontSize: "18px", color: "#ffffff", marginRight: "8px"}}/>}
                    Remove
                </Button>
            </DialogActions>
            </form>
        </Dialog>
    );
};
